// extracted by mini-css-extract-plugin
module.exports = {"counter":"styles_counter__s1D96","plus":"styles_plus__sKVdN","key":"styles_key__eM329"};